import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { SignInLogo } from './SignInLogo';

export const SigningInSpinner: React.FunctionComponent = () => {
  const [ showSigningIn, setShowSigningIn ] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShowSigningIn(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!showSigningIn) {
    return null;
  }

  return (
    <div className="tb-login tb-signing-in">
      <span className="tb-login-form-container">
        <SignInLogo/>
        <div className="tb-login-title">{Messages.signingIn()}</div>
        <span className="tb-icon-spinner-large-alternate"/>
      </span>
    </div>
  );
};
